<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="mt-5 pt-4 row justify-content-center">
        <div class="col-12 mb-3">
          <label style="color: #616161;"><strong>NUEVO PRODUCTO</strong></label><br>
        </div>

        <div class="col-12 m-0 p-0">
          <div class="form-group">
            <div class="row" style="text-align: left">
              <div class="col-7 m-0 p-0">
                <div class="row">
                  <div class="col-8">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Nombre *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.name }"
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        placeholder="Escribe aquí el nombre del producto "
                      />
                    </div>
                    <span
                      v-if="errors.name"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.name }}</span
                    >
                  </div>

                  <!-- <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><b>Color *</b>
                      </label>
                      <input
                        type="color"
                        class="form-control"
                        v-model="form.color"
                      />
                    </div>
                    <span
                      v-if="errors.color"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.color }}</span
                    >
                  </div> -->

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Estado del producto * </strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.status }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.status"
                      >
                        <option value="null" disabled selected
                        >Seleccione el estado de producto
                        </option>
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.status"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.status }}</span
                    >
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Tipo de producto * </strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_id }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_id"
                      >
                        <option value="null" disabled selected
                        >Seleccione el tipo de producto
                        </option>
                        <option value="3">Accesorios de motos</option>
                        <option value="5">Bonos</option>
                        <option value="7">Soat</option>
                        <option value="8">Punto de venta</option>
                        <option value="9">Boleto de rifa</option>
                        <option value="10">Boleto de Call of Duty</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_id"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_id }}</span
                    >
                  </div>

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color:#616161; font-size:14px"
                      ><strong>Tipo de catálogo *</strong>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_catalogue }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_catalogue"
                      >
                        <option value="null" disabled selected>Seleccione el tipo de catálogo</option>
                        <option value="1">Motero</option>
                        <option value="2">Lubricador</option>
                        <option value="3">Motero y Lubricador</option>
                        <option value="4">Puntos de Venta</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_catalogue"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_catalogue }}</span
                    >
                  </div>
                  <!-- si se escoge Todos en el tipo de catálogo -->
                  <div v-if="form.type_catalogue == 1 || form.type_catalogue == 3 || form.type_catalogue == 4" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Puntos *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.points }"
                        type="number"
                        v-model="form.points"
                        class="form-control"
                        placeholder="Escribe aquí los puntos del producto"
                      />
                    </div>
                    <span
                      v-if="errors.points"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.points }}</span
                    >
                  </div>

                  <!-- si se escoge Lubricador en el tipo de catálogo -->
                  <div v-if="form.type_catalogue == 2 || form.type_catalogue == 3" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Puntos Lubricador *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.points_lub }"
                        type="number"
                        v-model="form.points_lub"
                        class="form-control"
                        placeholder="Escribe aquí los puntos del producto"
                      />
                    </div>
                    <span
                      v-if="errors.points_lub"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.points_lub }}</span
                    >
                  </div>

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>Precio *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.price }"
                        type="number"
                        v-model="form.price"
                        class="form-control"
                        placeholder="Escribe aquí el precio del producto"
                      />
                    </div>
                    <span
                      v-if="errors.price"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.price }}</span
                    >
                  </div>
                  <!-- <div class="col-4">
                      <div class="form-group">
                      <label
                      class="ml-1"
                      for="state"
                      style="color: #616161; font-size: 14px"
                      ><b>Stock *</b>
                      </label>
                      <input
                      :class="{ 'is-danger': errors.stock }"
                      type="number"
                      v-model="form.stock"
                      class="form-control"
                      placeholder="Escribe aquí el precio del producto"
                      />
                      </div>
                      <span
                      v-if="errors.stock"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.stock }}</span
                      >
                  </div> -->
                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><strong>SKU *</strong>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.sku }"
                        type="text"
                        v-model="form.sku"
                        class="form-control"
                        placeholder="Escribe aquí el sku del producto"
                      />
                    </div>
                    <span
                      v-if="errors.sku"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.sku }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-5 m-0 p-0">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color:#616161; font-size:14px;"
                  ><strong>Descripción del producto *</strong>
                  </label>
                  <textarea
                    :class="{ 'is-danger': errors.description }"
                    rows="8"
                    type="text"
                    v-model="form.description"
                    class="form-control"
                    placeholder="Escribe aquí la descripción del producto"
                  />
                </div>
                <span
                  v-if="errors.description"
                  class="text-danger float-left small error-danger mb-2"
                >{{ errors.description }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="hr-border"></div>
        <div class="col-6" style="text-align: initial">
          <div class="form-group">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><strong>Tipo de talla {{ form.type_catalogue == 3 ? 'Motero' : '' }} *</strong>
            </label>
            <select
              :class="{ 'is-danger': errors.talla }"
              class="form-control"
              name="state"
              id="state"
              v-model="sizes.info"
            >
              <option value="null" disabled selected
              >Seleccione una talla
              </option>
              <option v-for="data in listSizes" :key="data.id" :value="data">
                {{ data.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-5" style="text-align: initial">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
          ><strong>Cantidad *</strong>
          </label>
          <input
            type="text"
            v-model="sizes.availability"
            class="form-control"
            placeholder="Escribe aquí la cantidad de productos para esa talla"
          />
        </div>

        <div class="col-1">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
          ><strong> Agregar </strong>
          </label>
          <button @click="addSizes()" class="btn btn-info">+</button>
        </div>

        <div class="col-12" style="text-align: initial">
          <label for="image" style="color:#616161; font-size:14px;">
            <strong>Tallas</strong>
          </label>
        </div>

        <div class="col-12">
          <div
            v-if="errors.sizes"
            class="alert alert-danger"
            role="alert"
          >
            No hay tallas seleccionadas, debe seleccionar al menos una talla o cantidad
          </div>
          <div
            v-else-if="form.sizes.length == 0"
            class="alert alert-primary"
            role="alert"
          >
            No hay tallas seleccionadas {{ form.type_catalogue == 3 ? 'para Motero' : '' }}
          </div>

          <div 
            v-for="(data, i) in form.sizes" 
            :key="data.id"
            class="btn-group"
          >
            <button
              type="button"
              class="btn btn-primary mb-3 ml-3"
            >
            <div>
              <span v-if="data.name != null">
                <strong> {{ data.name }} </strong>
              </span>
              <span class="badge badge-light ml-2">
                {{ data.availability }}
              </span>
              <span
                style="padding-left:5px"
                @click="removeSize(i)"
                class="fa fa-close icon ml-2 text-dark"
              ></span>
            </div>
            </button>
          </div>
        </div>
        <div class="hr-border"></div>

        <!-- Tallas de productos para Lubricadores -->
        <template v-if="form.type_catalogue == 3">
          <div class="col-6" style="text-align: initial">
            <div class="form-group">
              <label
                class="ml-1"
                for="state"
                style="color: #616161; font-size: 14px"
              ><strong>Tipo de talla {{ form.type_catalogue == 3 ? 'Lubricador' : '' }} *</strong>
              </label>
              <select
                class="form-control"
                name="state"
                id="state"
                v-model="sizes_lub.info"
              >
                <option value="null" disabled selected
                >Seleccione una talla
                </option>
                <option v-for="data in listSizes" :key="data.id" :value="data">
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-5" style="text-align: initial">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><strong>Cantidad *</strong>
            </label>
            <input
              type="text"
              v-model="sizes_lub.availability"
              class="form-control"
              placeholder="Escribe aquí la cantidad de productos para esa talla"
            />
          </div>

          <div class="col-1">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><strong>Agregar</strong>
            </label>
            <button @click="addSizesLub()" class="btn btn-info">+</button>
          </div>

          <div class="col-12" style="text-align: initial">
            <label for="image" style="color:#616161; font-size:14px;">
              <strong>Tallas</strong>
            </label>
          </div>

          <div class="col-12">
            <div
              v-if="errors.sizes_lub"
              class="alert alert-danger"
              role="alert"
            >
              No hay tallas seleccionadas, debe seleccionar al menos una talla o cantidad
            </div>
            <div
              v-else-if="form.sizes_lub.length == 0"
              class="alert alert-primary"
              role="alert"
            >
              No hay tallas seleccionadas {{ form.type_catalogue == 3 ? 'para Lubricador' : '' }}
            </div>

            <div 
              v-for="(data, i) in form.sizes_lub"
              :key="data.id"
            >
              <button
                type="button"
                class="btn btn-primary mb-3 ml-3"
              >
              <template>
                <template v-if="data.name != null">
                  <strong> {{ data.name }} </strong>
                </template>
                <span class="badge badge-light ml-2">
                  {{ data.availability }}
                </span>
                <span
                  style="padding-left:5px"
                  @click="removeSizeLub(i)"
                  class="fa fa-close icon ml-2 text-dark"
                ></span>
              </template>
              </button>
            </div>
          </div>
          <div class="hr-border"></div>
        </template>

        <div class="col-12">
          <form ref="form" style="text-align: initial">
            <label for="image" style="color: #616161; font-size: 14px"
            ><strong>Subir imagen *</strong></label
            ><br />
            <input
              type="file"
              multiple
              accept="image/*"
              id="image"
              name="image"
              class="form-control-file mb-2"
              style="color: black"
              @change="onfileSelected($event)"
              :class="{ 'is-danger': errorsFile || errorsFile2 }"
            />
            <span v-if="errorsFile2" class="text-danger small error-danger">{{
              errorsFile2
            }}</span>
            <span v-if="errorsFile" class="text-danger small error-danger">{{
              errorsFile
            }}</span
            ><br />
          </form>
          <div class="commentary">
            <span
            >RECOMENDACIÓN: solo se permiten imagenes en formato
              (jpg,jpeg,png).
            </span>
            <span>El tamaño maximo de 1MB.</span><br />
            <span
            >Para dispositivos de escritorio el tamaño de la imagen debe ser
              250 x 250 pixeles.</span
            >
          </div>
        </div>

        <div class="col-12 mt-3">
          <div 
            v-for="(data, i) in listFile" 
            :key="data.id"
          >
            <div id="imgSelect" class="form-check form-check-inline">
              <label class="radio-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  v-model="main"
                  :value="data"
                  id="flexRadioDefault2"
                />
                <img
                  width="150"
                  :class="`img-h-${i}`"
                  class="mr-3"
                  alt="Imágemes"
                />
              </label>
            </div>
          </div>
        </div>

        <div class="col-12 mt-3 mb-3" style="text-align: end">
          <button
            @click="clear()"
            type="button"
            class="btn btn-success btn-sm button-login mr-3"
          >
            Limpiar formulario
          </button>

          <button
            @click="createProduct()"
            type="button"
            class="btn btn-danger btn-sm button-login"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Agregar producto</template>
          </button>
        </div>

        <div class="hr-border"></div>

        <div class="col-12 mb-3 mt-3">
          <label style="color: #616161;"><strong>RELACIONAR IMÁGENES</strong></label
          ><br>
        </div>

        <div class="col-12" style="text-align: initial">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
          ><strong
          >Seleccione las imágenes que estarán relacionadas a este
            producto.</strong
          >
          </label>
          <multiselect
            :max="6"
            v-model="listRelations"
            tag-placeholder="Agregan item"
            placeholder="Buscar productos"
            label="name"
            :custom-label="nameWithLang"
            track-by="id"
            :options="listProducts"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>

        <div class="col-12">
          <span
            class="text-info float-left small mb-2 mt-2"
            style="text-align: initial"
          >Sólo se admiten 6 productos relacionados.</span
          >
        </div>

        <div class="col-12 mt-3 mb-3" style="text-align: end">
          <button
            v-if="showBtn.s2"
            @click="clear()"
            type="button"
            class="btn btn-success btn-sm button-login mr-3"
          >
            Limpiar formulario
          </button>

          <button
            @click="imgRelations()"
            type="button"
            class="btn btn-info btn-sm button-login"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Agregar relación</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from "vue-multiselect";
  import $ from "jquery";
  import axios from 'axios'

  export default {
    components: { Multiselect },
    data() {
      return {
        listSizes: [],
        showBtn: {
          s1: false,
          s2: false,
        },
        productId: null,
        main: null,
        value: [],
        listRelations: [],
        listProducts: [],
        listFile: [],
        searchN: "",
        errorsFile: false,
        errorsFile2: false,
        errorsTitle: false,
        errorsStatus: false,
        sizes: {
          info: null,
          availability: null,
        },
        sizes_lub: {
          info: null,
          availability: null,
        },
        type_size: null,
        form: {
          id: 0,
          urlImg: "",
          name: "",
          status: null,
          type_catalogue: null,
          points: 0,
          points_lub: 0,
          price: null,
          description: "",
          color: null,
          type_id: null,
          sku: null,
          sizes: [],
          sizes_lub: [],
        },
        errors: {
          id: 0,
          urlImg: "",
          tallas: "",
          name: "",
          status: null,
          type_catalogue: null,
          points: null,
          points_lub: null,
          price: null,
          description: "",
          listR: false,
          type_id: null,
          sku: null,
          sizes: false,
          sizes_lub: false,
        },
        currentForm: {},
        file: null,
        loading: {
          publicate: false,
          history: false,
          changeDoc: false,
          order: false,
        },
        hidden: {
          btn: false,
        },
        paginate: ["items"],
        page: 1,
        totalPage: 1,
        isWon: false,
      };
    },
    methods: {
      getSizes() {
        axios
          .get("superAdmin/get/list/size")
          .then((res) => {
            if (res.data.cod == 0) {
              this.listSizes = res.data.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      removeSize(i) {
        this.form.sizes.splice(i, 1);
      },
      removeSizeLub(i) {
        this.form.sizes_lub.splice(i, 1);
      },
      addSizes() {
        if (this.sizes.info == null) {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: "El Tipo de talla es obligatorio.",
            confirmButtonColor: "#dc3545"
          });
          return false;
        }
        else if (this.sizes.availability == null || this.sizes.availability == 0) {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: "La Cantidad es obligatoria.",
            confirmButtonColor: "#dc3545"
          });
          return false;
        } else {
          let idSize = this.form.sizes.find((element) => element.id == this.sizes.info.id);
          if(idSize){
            this.$swal({
              icon: "warning",
              title: "Oops...",
              html: `La talla <strong style="color:#dc3545">${idSize.name}</strong> ya fue agregada con <strong style="color:#dc3545">${idSize.availability}</strong> unidades.`,
              confirmButtonColor: "#dc3545"
            });
            return false;
          } else {
            this.form.sizes.push({
              name: this.sizes.info.name,
              id: this.sizes.info.id,
              availability: this.sizes.availability,
            });
            setTimeout(() => {
              this.sizes.info = null;
              this.sizes.availability = null;
            }, 20);
          }
        }
      },
      addSizesLub() {
        if (this.sizes_lub.info == null) {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: "El Tipo de talla es obligatorio.",
            confirmButtonColor: "#dc3545"
          });
          return false;
        }
        else if (this.sizes_lub.availability == null || this.sizes_lub.availability == 0) {
          this.$swal({
            icon: "warning",
            title: "Oops...",
            text: "La Cantidad es obligatoria.",
            confirmButtonColor: "#dc3545"
          });
          return false;
        } else {
          let idSizeLub = this.form.sizes_lub.find((element) => element.id == this.sizes_lub.info.id);
          if(idSizeLub){
            this.$swal({
              icon: "warning",
              title: "Oops...",
              html: `La talla <strong style="color:#dc3545">${idSizeLub.name}</strong> ya fue agregada con <strong style="color:#dc3545">${idSizeLub.availability}</strong> unidades.`,
              confirmButtonColor: "#dc3545"
            });
            return false;
          } else {
            this.form.sizes_lub.push({
              name: this.sizes_lub.info.name,
              id: this.sizes_lub.info.id,
              availability: this.sizes_lub.availability,
            });
            setTimeout(() => {
              this.sizes_lub.info = null;
              this.sizes_lub.availability = null;
            }, 20);
          }
        }
      },
      clear() {
        // this.showBtn.s1 = false;
        this.showBtn.s2 = false;
        this.listRelations = [];
        this.listFile = [];
        this.form.id = 0;
        this.form.name = "";
        this.form.color = null;
        this.form.status = null;
        this.form.type_id = null;
        this.form.points = null;
        this.form.price = null;
        this.form.sku = null;
        this.form.description = "";
        this.form.urlImg = "";
        this.form.sizes = null;
  
        setTimeout(() => {
          window.location.reload();
          // this.errors = {
          // id: false,
          // urlImg: false,
          // name: false,
          // status: false,
          // points: false,
          // price: false,
          // description: false,
          // listR: false,
          // type_id: false,
          // sizes: false,
          // };
        },0);
        this.productId = null;
      },
      nameWithLang({ name, description, product_type_id }) {
        if (
          product_type_id == 1 ||
          product_type_id == 2 ||
          product_type_id == 4
        ) {
          return `${name} — ${description}`;
        } else {
          return `${name}`;
        }
      },
      onfileSelected(event) {
        let app = this;
        var fileSize = null;
        var extension = null;
        var url1 = null;
        this.listFile = [];
        if (event.target.files.length < 5) {
          for (let i = 0; i < event.target.files.length; i++) {
            fileSize = event.target.files[i].size;
            extension = event.target.files[i].name.split(".");
            if (fileSize > 1000000) {
              this.errorsFile = "El archivo no debe superar 1MB. ";
              return false;
            }
            if (
              extension[1] != "jpg" &&
              extension[1] != "png" &&
              extension[1] != "jpeg"
            ) {
              this.errorsFile2 = " La extensión es inválida. ";
              return false;
            } else {
              this.errorsFile = false;
              this.errorsFile2 = false;
              var reader = new FileReader();
              reader.readAsDataURL(event.target.files[i]);
              reader.onload = function(e) {
                url1 = e.target.result;
                $(".img-h-" + i).attr("src", e.target.result);
              };
              app.listFile.push({ file: event.target.files[i], index: i });
            }
          }
          // console.log(this.listFile)
        } else {
          this.errorsFile = "No se pueden adjuntar más de 4 imágenes. ";
          return false;
        }
      },
      search() {
        this.items = [];
        this.loading.history = true;
        axios
          .get("superAdmin/product/moto/" + this.searchN)
          .then((res) => {
            if (res.data.cod == 0) {
              this.items = res.data.data;
              this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
            }
            this.loading.history = false;
          })
          .catch((error) => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      validform() {
        let app = this;
        if (!app.form.name) {
          app.errors.name = "El nombre del producto es requerido.";
          return false;
        }
        if (!app.form.status) {
          app.errors.status = "El estado del producto es requerido.";
          return false;
        }
        if (!app.form.type_id) {
          app.errors.type_id = "El tipo del producto es requerido.";
          return false;
        }
        if(!app.form.type_catalogue){
          app.errors.type_catalogue = "El tipo de catálogo es requerido";
          return false;
        }
        if(app.form.type_catalogue == 1){
          if (!app.form.points) {
            app.errors.points = "La cantidad de puntos es requerida.";
            return false;
          }
        }
        if(app.form.type_catalogue == 2){
          if (!app.form.points_lub) {
            app.errors.points_lub = "La cantidad de puntos es requerida.";
            return false;
          }
        }
        if(app.form.type_catalogue == 3){
          if (!app.form.points) {
            app.errors.points = "La cantidad de puntos es requerida.";
            return false;
          }
          if (!app.form.points_lub) {
            app.errors.points_lub = "La cantidad de puntos es requerida.";
            return false;
          }
        }
        if (!app.form.price) {
          app.errors.price = "El precio del producto es requerido.";
          return false;
        }
        if (!app.form.sku) {
          app.errors.sku = "El sku es requerido.";
          return false;
        }
        if (!app.form.description) {
          app.errors.description = "La descripción del producto es requerida.";
          return false;
        }
        if(app.form.type_catalogue == 1){
          if(app.form.sizes.length == 0){
            app.errors.sizes = true;
            return false;
          }
        }
        if(app.form.type_catalogue == 2){
          if(app.form.sizes_lub.length == 0){
            app.errors.sizes_lub = true;
            return false;
          }
        }
        if(app.form.type_catalogue == 3){
          if(app.form.sizes.length == 0){
            app.errors.sizes = true;
            return false;
          }
          if(app.form.sizes_lub.length == 0){
            app.errors.sizes_lub = true;
            return false;
          }
        }
        if (app.listFile.length == 0) {
          app.errorsFile = "La imagen es requerida";
          return false;
        }
  
        if (
          !app.errorsFile &&
          !app.errorsTitle &&
          !app.errors.name &&
          !app.errors.status &&
          !app.errors.type_id &&
          !app.errors.description &&
          !app.errors.type_catalogue &&
          !app.errors.points &&
          !app.errors.points_lub &&
          !app.errors.price &&
          !app.errors.sku &&
          !app.errors.sizes &&
          !app.errors.sizes_lub
        ) {
          return true;
        }
        return false;
      },
      createProduct() {
        let app = this;
        if (app.validform()) {
          app.saveProduct(app.file);
        }
      },
      reset() {
        this.form.name = "";
        this.form.status = null;
        this.form.description = "";
        this.form.points = null;
        this.form.price = null;
        this.form.sku = null;
        this.form.sizes = null;
        this.errorsFile = false;
        this.errorsTitle = false;
        this.errorsStatus = false;
        this.errorsStatus = false;
        this.$refs.form.reset();
        this.file = null;
        setTimeout(() => {
          this.errorsTitle = false;
          this.errorsFile = false;
          this.errors.name = false;
          this.errors.status = false;
          this.errors.type_id = false;
          this.errors.description = false;
          this.errors.points = false;
          this.errors.price = false;
          this.errors.sizes = false;
        }, 0);
      },
      saveProduct() {
        if(this.main == null){
          alert("Por favor seleccione la imágen principal de su producto");
          document.getElementById("imgSelect").style.background ="red";
        }
        const formData = new FormData();
        formData.append("img", this.main.file);
        formData.append("name", this.form.name);
        formData.append("description", this.form.description);
        formData.append("status_id", this.form.status);
        formData.append("type_catalogue", this.form.type_catalogue);
        formData.append("points", this.form.points);
        formData.append("points_lub", this.form.points_lub);
        formData.append("price", this.form.price);
        formData.append("color", this.form.color);
        formData.append("type_id", this.form.type_id);
        formData.append("sku", this.form.sku);
  
        this.loading.changeDoc = true;
        axios
          .post("superAdmin/product/moto", formData)
          .then((res) => {
            // console.log('res: ', JSON.stringify(res));
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              // this.showBtn.s1 = true;
              this.loading.changeDoc = false;
              this.getProducts();
              this.productId = res.data.data.id;
              this.saveSizes(res.data.data.id);
              this.saveAllImg(res.data.data.id);
              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      saveSizes(id) {
        var data = {
          productId: id,
          sizes: this.form.sizes,
          sizes_lub: this.form.sizes_lub,
        };
        this.loading.changeDoc = true;
        axios
          .post("api/size/assign", data)
          .then((res) => {
            this.loading.changeDoc = false;
            if (res.data.cod == 0) {
              // this.$swal({
              //   confirmButtonColor: "#dc3545",
              //   icon: "success",
              //   title: "Muy bien",
              //   text: res.data.message,
              // });
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      saveAllImg(id) {
        const formData1 = new FormData();
        var list = [];
        for (let i = 0; i < this.listFile.length; i++) {
          if (this.listFile[i].file.name != this.main.file.name) {
            list.push(this.listFile[i].file);
          }
        }
        for (let j = 0; j < list.length; j++) {
          formData1.append("imgs[" + j + "]", list[j]);
        }
        formData1.append("productId", id);
        axios
          .post("superAdmin/product/imgs/assign", formData1)
          .then((res) => {
            if (res.data.cod == 0) {
              // this.$swal({
              //   confirmButtonColor: "#dc3545",
              //   icon: "success",
              //   title: "Muy bien",
              //   text: res.data.message,
              // });
              this.loading.changeDoc = false;
              this.getProducts();
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      imgRelations() {
        var listP = [];
        // console.log(this.listRelations);
        // console.log(this.listRelations.length);
  
        for (let i = 0; i < this.listRelations.length; i++) {
          listP.push({ id: this.listRelations[i].id });
        }
        // console.log(listP);
  
        var data = {
          productId: this.productId,
          products: listP,
        };
        // console.log(data);
        axios
          .post("superAdmin/product/related/assign", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.showBtn.s2 = true;
              this.loading.changeDoc = false;
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      getProducts() {
        this.listProducts = [];
        axios
          .get("superAdmin/product/moto")
          .then((res) => {
            if (res.data.cod == 0) {
              this.listProducts = res.data.data;
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      pageChange(toPage) {
        this.page = toPage;
      },
    },
    mounted() {
      this.getSizes();
      this.pageChange(1);
      this.getProducts();
    },
    watch: {
      value: function(newV) {
        if (newV.length >= 6) {
          this.errors.listR = "Sólo se admiten 6 productos relacionados";
        } else {
          this.errors.listR = false;
        }
      },
      searchN: function(newN) {
        if (!newN) {
          setTimeout(() => this.getProducts(), 15000);
        }
      },
      "form.name": function(newV) {
        if (!newV) {
          this.errors.name = "El nombre del producto es requerido.";
        } else {
          this.errors.name = false;
        }
      },
      "form.sku": function(newV) {
        if (!newV) {
          this.errors.sku = "El sku es requerido.";
        } else {
          this.errors.sku = false;
        }
      },
      "form.description": function(newV) {
        if (!newV) {
          this.errors.description = "La descripción del producto es requerida.";
        } else {
          this.errors.description = false;
        }
      },
      "form.type_catalogue": function(newV){
        if(!newV){
          this.errors.type_catalogue = "El tipo de catálogo es requerido";
        } else {
          this.errors.type_catalogue = false;
        }
      },
      "form.points": function(newV) {
        if (!newV) {
          this.errors.points = "La cantidad de puntos es requerida.";
        } else {
          this.errors.points = false;
        }
      },
      "form.points_lub": function(newV) {
        if (!newV) {
          this.errors.points_lub = "La cantidad de puntos es requerida.";
        } else {
          this.errors.points_lub = false;
        }
      },
      "form.price": function(newV) {
        if (!newV) {
          this.errors.price = "El precio del producto es requerido.";
        } else {
          this.errors.price = false;
        }
      },
      "form.status": function(newV) {
        if (!newV) {
          this.errors.status = "El estado del producto es requerido.";
        } else {
          this.errors.status = false;
        }
      },
      "form.sizes": function(newV) {
        if (!newV) {
          this.errors.sizes = "No ha seleccionado tallas.";
        } else {
          this.errors.sizes = false;
        }
      },
      "form.sizes_lub": function(newV) {
        if (!newV) {
          this.errors.sizes_lub = "No ha seleccionado tallas para Lubricador.";
        } else {
          this.errors.sizes_lub = false;
        }
      },
      "form.type_id": function(newV) {
        if (!newV) {
          this.errors.type_id = "El tipo del producto es requerido.";
        } else {
          this.errors.type_id = false;
        }
      },
      "form.urlImg": function(newV) {
        if (!newV) {
          this.errors.urlImg = "La imagen del producto es requerida.";
        } else {
          this.errors.urlImg = false;
        }
      },
    },
  };
</script>
  
<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
 padding-right: 0px !important;
 padding-left: 0px !important;
 overflow: hidden;
}

.hr-border {
 border-top: 1px solid rgb(198 198 198);
 height: 15px;
 width: 100%;
 background-color: white;
}

.div-button {
 margin-top: 50px;
 text-align: left;
}

.is-danger {
 border: solid 2px !important;
 border-color: #e9434c !important;
}

.modal-title {
 color: black;
 font-weight: bold;
}

.modal-question {
 border: solid 3px;
 border-color: #dc3545;
 border-radius: 15px;
}

label {
 color: black;
 margin-right: 4px;
}

.img-banner {
 display: block;
 width: 25%;
 text-align: center;
 margin: auto;
}

td {
 text-align: center;
 vertical-align: -webkit-baseline-middle;
 cursor: all-scroll;
}

.table-container {
 overflow: auto;
}

h5 {
 margin-bottom: 10px !important;
}

.commentary {
 text-align: left;
 color: #1da5df;
 font-size: 13px;
}

.page-item.active .page-link {
 border-style: none;
 border-radius: 20px;
 background-color: #dc3545;
}

a.page-link {
 color: black;
 cursor: pointer;
}

a.page-link:hover {
 color: #dc3545;
}

.page-link {
 background-color: #f5f5dc00;
 border-radius: 20px;
 border-color: none;
}

.page-item.disabled .page-link {
 color: #dc3545;
 background-color: #fff0;
 border-color: #dee2e600;
}

.ul-pagination {
 padding: 0px;
}

.multiselect__tag {
 background-color: #dc3545 !important;
}
.multiselect__tag-icon:after {
 color: #ffffff;
 font-size: 18px;
}
.multiselect__tag-icon:hover {
 color: #ffffff;
 font-size: 18px;
 background-color: #b80012;
}

.multiselect__option--highlight {
 background: #17a2b8;
 outline: none;
 color: #fff;
}
.alert-danger {
 border-color: red !important;
}
</style>